import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import fetchNewspaperByPublicationIdAndDatehunk from '../store/newspapers/actions/fetchNewspaperByPublicationIdAndDate';
import { singleNewspaperStateSelector, } from '../store/newspapers/newspapersSelectors';
export var useNewspaperByIdActionsDispatches = function () {
    var dispatch = useDispatch();
    var fetchNewspaperByPublicationIdAndDate = useCallback(function (id, date) { return dispatch(fetchNewspaperByPublicationIdAndDatehunk(id, date)); }, [dispatch]);
    return { fetchNewspaperByPublicationIdAndDate: fetchNewspaperByPublicationIdAndDate };
};
/**
 * A custom hook that fetches a single newspaper (which is only uniquely identifiable by a combination of its publication id and date)
 * and returns the relevant information of the "newspapers" state, including the fetched newspaper.
 * It uses the `singleNewspaperStateSelector` and its related actions.
 */
// eslint-disable-next-line max-len
var useNewspaperByPublicationIdAndDate = function (id, date) {
    var state = useSelector(singleNewspaperStateSelector(id, date));
    var actions = useNewspaperByIdActionsDispatches();
    return [state, actions];
};
export default useNewspaperByPublicationIdAndDate;
